/**
 * Canonical production UI (Firebase Hosting custom domain).
 * API traffic remains on https://api.titan-trading.live — see `src/lib/api.ts` (API_BASE).
 */
export const UI_CANONICAL_ORIGIN = 'https://titan-trading.live';
